import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import type { ServicesReportCreatePayload } from '@blade/trade-api-client'

export const reportRequestAction = action(
  async (ctx, payload: ServicesReportCreatePayload) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = (
      await ctx.schedule(() =>
        apiRequest(ctx, tradeApiClient.services.servicesReportCreate, [
          payload,
        ]),
      )
    ).pipe(Result.mapError(ApiError.fallbackToUnknown))

    return result
  },
  'reportRequestAction',
)
